<section fxFlex class="material-story w-100" fxLayout="column" fxLayoutAlign="center stretch">
    <app-hero-title fxFlex fxHide.lt-sm="true" class="" title="MARIS FAQs"></app-hero-title>
    <div ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl" fxFlex class="faq-content w-100" fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex class="faq-container w-100" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="70">
            <div class="search-input-wrapper1" fxLayout="row" fxLayoutAlign="start center" ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl">
                <input fxFlex type="text" class="search-input" placeholder="Search faq" matInput (keydown)="filter($event.target.value)" #messageInput />
                <mat-icon matSuffix fxLayout="row" fxLayoutAlign="center center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon-sm" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                    </svg>
                </mat-icon>
            </div>
            <div ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl" class="faq-panels-wrapper w-100" *ngIf="vm$ | async as vm" fxLayout="column" fxLayoutAlign="start stretch">
                <ng-container fxFlex *ngFor="let item of vm.filteredFaqGroups">
                    <h5 class="pt-3 super-title" fxFlex>{{ item.title }}</h5>
                    <mat-accordion fxFlex>
                        <mat-expansion-panel *ngFor="let faq of item.content">
                            <mat-expansion-panel-header class="fw-bold item-title">
                                <div [innerHTML]="faq.title | highlight : searchValue"></div>
                            </mat-expansion-panel-header>
                            <div class="item-text" [innerHTML]="faq.content | highlight : searchValue"></div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </ng-container>
            </div>
        </div>
    </div>
</section>
